export default function initSellerReviews () {
  const btn = document.querySelector('#vjs-seller-reviews-more button')
  if (!btn) return

  btn.addEventListener('click', () => {
    const hidden = document.querySelectorAll('#vjs-seller-reviews-list .vjs-seller-review.hidden')
    Array.from(hidden).slice(0, 3).forEach(el => el.classList.remove('hidden'))
    if (!document.querySelector('#vjs-seller-reviews-list .vjs-seller-review.hidden')) {
      document.getElementById('vjs-seller-reviews-more').remove()
    }
  })
}
